<template>
  <div class="page-form">
    <h3 class="title">{{ conditions.batch_type_text }}</h3>
    <affix>
      <div class="tools">
        <form-button
          v-if="conditions.batch_status === 'E001'"
          type="default"
          icon="form-advance"
          @click="batchHandle('SAVE')"
        >保存</form-button>
        <form-button
          v-if="conditions.batch_status === 'E001'"
          type="default"
          icon="form-advance"
          @click="batchHandle('CANCEL')"
        >取消</form-button>
        <form-button
          type="default"
          icon="form-advance"
          @click="$emit('change-action', 'query')"
        >返回</form-button>
      </div>
    </affix>

    <div class="form-container">
      <el-form size="mini" inline disabled label-width="100px">
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="批次号">
              <el-input v-model="conditions.batch_number" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="附件名称">
              <el-input v-model="conditions.file_name" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="批导类型">
              <el-select v-model="conditions.batch_type">
                <el-option
                  v-for="item in selectDataOptions['A0044']"
                  :key="item.key"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="处理状态">
              <el-select v-model="conditions.batch_status">
                <el-option
                  v-for="item in selectDataOptions['A0030']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="导入日期">
              <el-input v-model="conditions.datum" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="批导人">
              <el-input v-model="conditions.batch_name" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="销售计划批导明细" :custome-config="() => vxeShowCustom('xTable')">
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        />
      </TableCommon>
    </div>
  </div>
</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { apiInvoiceImportDetail, apiInvoiceImportCancelSave } from '@/api/sap/make-invoice-sap'
export default {
  props: ['batchNum'],
  data() {
    return {
      conditions: {
        batch_number: '',
        batch_type: '',
        batch_status: '',
        file_name: '',
        uname: '',
        datum: ''
      },
      selectDataOptions: {},
      gridOptions: {
        columns: [
          { field: 'batch_status_text', title: '处理状态', width: 120 },
          { field: 'message', title: '消息', width: 200 },
          { field: 'w_invo_infoid', title: '原制票通知单编号', width: 150 },
          { field: 'invo_infoid', title: '制票通知单编号', width: 150 },
          { field: 'inf_type_text', title: '制票通知单类型', width: 180 },
          { field: 'customer', title: '开票客户', width: 120 },
          { field: 'cust_name', title: '开票客户名称', width: 200 },
          { field: 'recinv_pers', title: '收票联系人', width: 120 },
          { field: 'recinv_tel', title: '收票联系人电话', width: 120 },
          { field: 'inv_addr', title: '收票地址', width: 120 },
          { field: 'mark_print', title: '是否打印', width: 120 },
          { field: 'inv_type', title: '发票类型', width: 120 },
          { field: 'inv_type_dscr', title: '发票类型描述', width: 120 },
          { field: 'chan_date', title: '换票日期', width: 120 },
          { field: 'mak_date', title: '开票日期', width: 120 },
          { field: 'inv_amount', title: '发票总金额', width: 120 },
          { field: 'zzfld000001', title: '营销单元', width: 120 },
          { field: 'zzfld000001_dscr', title: '营销单元描述', width: 120 },
          { field: 'zzfld000002', title: '省份', width: 120 },
          { field: 'zzfld000003', title: '城市', width: 120 },
          { field: 'zzfld000004', title: '业务员', width: 120 },
          { field: 'zzfld00002d', title: '创建人', width: 120 },
          { field: 'zzfld00002d_dscr', title: '创建人姓名', width: 120 },
          { field: 'datum', title: '创建时间', width: 120 },
          { field: 'inv_status', title: '状态', width: 120 },
          { field: 'inv_status_dscr', title: '状态描述', width: 120 },
          { field: 'audit_comment', title: '审核意见', width: 120 },
          { field: 'remark', title: '抬头备注', width: 120 },
          { field: 'zzfld00002j', title: '客户性质', width: 120 },
          { field: 'zzfld00002j_dscr', title: '客户性质描述', width: 120 },
          { field: 'zzfld00002k', title: '发货类型', width: 120 },
          { field: 'zzfld00002k_dscr', title: '发货类型描述', width: 120 },
          { field: 'zzfld00002l', title: '收货联系人', width: 120 },
          { field: 'zzfld00002m', title: '收货联系电话', width: 120 },
          { field: 'zzfld00002n', title: '收货地址', width: 120 },
          { field: 'invo_item', title: '制票通知单行项目号', width: 120 },
          { field: 'plan_number', title: '销售计划编号', width: 120 },
          { field: 'object_id', title: '订单编号', width: 120 },
          { field: 'order_number_int', title: '订单行项目号', width: 120 },
          { field: 'order_customer', title: '订单客户', width: 120 },
          { field: 'order_cust_name', title: '订单客户名称', width: 120 },
          { field: 'ordered_prod', title: '产品编号', width: 120 },
          { field: 'description', title: '产品描述', width: 120 },
          { field: 'zzfld00002s', title: '规格型号', width: 120 },
          { field: 'zzfld00002t', title: '单位', width: 120 },
          { field: 'use_quantity', title: '数量', width: 120 },
          { field: 'use_zzfld9', title: '件数', width: 120 },
          { field: 'zzfld00002e', title: '税率', width: 120 },
          { field: 'net_price', title: '含税单价', width: 120 },
          { field: 'net_value', title: '价税合计', width: 120 },
          { field: 'zzfld00002a', title: '折扣类型', width: 120 },
          { field: 'zzfld00002f', title: '单品折扣', width: 120 },
          { field: 'zzfld00002g', title: '折后含税单价', width: 120 },
          { field: 'zzfld00002i', title: '折扣额', width: 120 },
          { field: 'guaranty', title: '随量保证金', width: 120 },
          { field: 'send_qty', title: '已发运数量', width: 120 },
          { field: 'warehouse', title: '仓库', width: 120 },
          { field: 'warehouse_dscr', title: '仓库描述', width: 120 },
          { field: 'invo_id', title: '发票号', width: 120 },
          { field: 'manual_invo', title: '提货票', width: 120 },
          { field: 'item_remark', title: '行项目备注', width: 120 }
        ],
        data: []
      }
    }
  },
  created() {
    this.getSelectDictDataOrigin('A0044')
    this.getSelectDictDataOrigin('A0030')
    this.batchNum && this.getDetail()
  },
  methods: {
    async batchHandle(mode) {
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        mode,
        head: this.conditions
      }
      if (mode === 'SAVE') {
        params.item = this.gridOptions.data
      }
      const res = await apiInvoiceImportCancelSave(params)
      if (res.msgtype === 'S') {
        this.$message.success(res.message)
        Object.assign(this.conditions, res.data.head)
      } else {
        this.$message.warning(res.message)
      }
    },
    async getDetail() {
      const { data } = await apiInvoiceImportDetail({ batch_number: this.batchNum })
      Object.assign(this.conditions, data.head)
      this.gridOptions.data = data.item
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/invoice-manage/components/BatchImport.vue